<script>
    import { onMount, afterUpdate } from 'svelte';
    import { current_lang, translations } from '../stores.js';
    import {push} from 'svelte-spa-router'

    export let venues;
    export let artists;
    export let display_date;

    function get_venues_with_artists(){
        let venues_with_artists = [];
        for(let i = 0; i < venues.length; i++){
            let venue_artists = get_artists_for_venue(venues[i].id, i);
            venues_with_artists.push(venue_artists);
        }
        return venues_with_artists;
    }

    function order_by_start_time(artists){
        artists.sort((a, b) => {
            if ( a.sort_time < b.sort_time ){
                return -1;
            }
            if ( a.sort_time > b.sort_time ){
                return 1;
            }
            return 0;
        });
        return artists;
    }

    function get_artists_for_venue(venue_id, venue_order = null){
        let artists_for_venue = [];
        for(let i = 0; i < artists.length; i++){
            let artist = artists[i];
            let shows_for_venue = get_artist_shows_for_venue(artist.shows, venue_id);
            // if(venue_id == 191){
            //     console.log(artist)
            // }
            if(shows_for_venue.length > 0){
                for(let n = 0; n < shows_for_venue.length; n++){
                    let appearance_info = structure_appearance_info_for_list(artist, shows_for_venue[n]);
                    artists_for_venue.push(appearance_info);
                }
            }
        }

        artists_for_venue = order_by_start_time(artists_for_venue);

        return artists_for_venue;
    }

    function structure_appearance_info_for_list(artist, appearance){
        let time = "";
        let sort_time = "";
        if(appearance.startTime != null && appearance.startTime != ""){
            let time_parts = appearance.startTime.split(":");
            
            time = time_parts[0]+"."+time_parts[1];

            if(time_parts[0] == "00"){
                time_parts[0] = "24";
                sort_time = time_parts[0]+"."+time_parts[1];
            }else{
                sort_time = time;
            }
            
        }
        let appearance_info = {
            "id": artist.id,
            "name": artist.title,
            "time": time,
            "sort_time": sort_time,
        };

        if(appearance.admission){
            appearance_info.admission = true;
        }

        if(appearance.ticketsText && appearance.ticketsText != ""){
            appearance_info.ticketsTextFi = appearance.ticketsText;
            appearance_info.ticketsTextEn = appearance.ticketsText;

            if(appearance_info.ticketsTextFi == "Pääsymaksu, liput ovelta"){
                appearance_info.ticketsTextEn = "Entrance fee, tickets at the door";
            }
        }

        return appearance_info;
    }

    function get_artist_shows_for_venue(shows, venue_id){
        let shows_for_venue = [];
        for(let i = 0; i < shows.length; i++){
            if(shows[i].place.term_id == venue_id){
                shows_for_venue.push(shows[i]);
            }
        }
        
        return shows_for_venue;
    }



    let venue_artists = null;
    onMount(() => {
        venue_artists = get_venues_with_artists();
    });

	afterUpdate(() => {
		venue_artists = get_venues_with_artists();
	});

    //routing to single artist page
    function show_artist(artist_id){
        push('/artist/'+artist_id);
    }
</script>
<div class="schedule-main-container">
    {#if venue_artists != null}
        {#each venue_artists as artists, i}
            {#if artists.length > 0}
                <h4 class="venue-title">{@html venues[i].name} / {display_date}</h4>
                <div class="venue-schedule">
                    <div class="venue-schedule-row title-row">
                        <div class="schedule-time">{$translations["TIME"][$current_lang]}</div>
                        <div class="schedule-name">{$translations["ARTIST"][$current_lang]}</div>
                    </div>
                    {#each artists as artist}
                        <div class="venue-schedule-row info">
                            <div class="schedule-time">{artist.time}</div>
                            <div  class="schedule-name" on:click={() => show_artist(artist.id)}>{@html artist.name}</div>
                            {#if (artist.ticketsTextFi && artist.ticketsTextFi != "") || (artist.ticketsTextEn && artist.ticketsTextEn != "")}
                                <div class="tickets-info">
                                    {#if $current_lang == "FI"}
                                        <span>{artist.ticketsTextFi}</span>
                                    {/if}
                                    {#if $current_lang == "EN"}
                                        <span>{artist.ticketsTextEn}</span>
                                    {/if}
                                </div>
                            {:else if artist.admission}
                                <div class="tickets-info">
                                    {#if $current_lang == "FI"}
                                        <span>Pääsymaksu</span>
                                    {/if}
                                    {#if $current_lang == "EN"}
                                        <span>Entrance fee</span>
                                    {/if}
                                </div>
                            {/if}
                        </div>
                    {/each}
                </div>
            {/if}
        {/each}
    {/if}
</div>

<style>

    .venue-schedule-row{
        border-bottom: 2px solid #f2f2f2;
        padding: 10px 0px 10px 5px;

        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: left;
        gap: 30px;
    }
    .schedule-time{
        width: 60px;
        min-width: 60px;
        text-align: left;
        display: flex;
        flex-direction: column;
        align-items:  left;
        justify-content: center;

        font-family: 'futura-pt', Arial;
        font-weight: 700;
        font-size: 0.9rem;
        color: #000;
        text-transform: none;
    }
    .schedule-name{
        text-align: left;
        display: flex;
        flex-direction: column;
        align-items:  flex-start;
        justify-content: center;

        font-family: 'futura-pt', Arial;
        font-weight: 700;
        font-size: 0.9rem;
        color: #000;
        text-transform: none;
    }
    .tickets-info{
        text-align: left;
        display: flex;
        flex-direction: column;
        align-items:  flex-end;
        justify-content: center;

        font-weight: 700;
        font-size: 0.9rem;
        color: #000;
        text-transform: none;
        font-family: 'futura-pt', Arial;
    }
    .tickets-info span{
        border: 1px solid var(--darker-medium-color);
        padding: 5px;
        box-sizing: border-box;
        text-align: center;
    }
    .title-row{
        background-color: #000;
        color: #fff;

        
        border-radius: 2px;
    }
    .title-row .schedule-time,.title-row .schedule-name{
        color: #fff;
        text-transform: uppercase;
    }

    .venue-schedule{
        margin: 15px 0 60px 0;
    }
    h4{
        text-transform: uppercase;
    }

    :global(h4.venue-title svg){
        fill: #000;
    }

    .venue-schedule-row.info .schedule-name{
        cursor: pointer;
    }
</style>